import Vue from 'vue'
import Router from 'vue-router'
import Shutdown from './views/Shutdown.vue'
import { SUPPORTED_LANGUAGES, DEFAULT_LANGUAGE } from './translations/config'
import {i18n} from './translations/i18n'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/mep',
      name: 'mep',
      component: () => import('./views/Mep.vue'),
    },
    {
      path: '',
      redirect: `/${DEFAULT_LANGUAGE}`,
    },
    {
      path: '/:lang',
      name: 'landing',
      component: Shutdown,
      beforeEnter: beforeEnter,
    },
    {
      path: '/:lang/privacy',
      name: 'privacy',
      component: () => import('./views/Privacy.vue'),
      beforeEnter: beforeEnter,
    },
    {
      path: '/:lang/thanks',
      name: 'thanks',
      component: () => import('./views/Thanks.vue'),
      beforeEnter: beforeEnter,
      props: true
    },
    {
      path: '/:lang/recurring-signup',
      name: 'recurring-signup',
      component: () => import('./views/RecurringSignup.vue'),
      beforeEnter: beforeEnter,
      props: true
    },
    {
      path: '/:lang/recurring-signup/confirmation',
      name: 'recurring-signup-confirmation',
      component: () => import('./views/RecurringSignupConfirmation.vue'),
      beforeEnter: beforeEnter,
      props: true
    },
    {
      path: '/:lang/recurring-signup/success',
      name: 'recurring-signup-success',
      component: () => import('./views/RecurringSignupSuccess.vue'),
      beforeEnter: beforeEnter,
      props: true
    },
    {
      path: '/:lang/recurring-settings',
      name: 'recurring-settings',
      component: () => import('./views/RecurringSettings.vue'),
      beforeEnter: beforeEnter,
      props: true
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return {
        selector: to.hash
      }
    } else if (savedPosition) {
      return savedPosition
    } else {
      return {x: 0, y: 0}
    }
  }

})

function beforeEnter(to, from, next){
  const lang = to.params.lang

  if(!SUPPORTED_LANGUAGES.includes(lang)) return next('en')
  if (i18n.locale == lang) return next()

  import(`./translations/${lang}.json`).then((msg) => {
    i18n.setLocaleMessage(lang, msg.default || msg)
    i18n.locale = lang
    return next()
  })

}
